
import React, { useEffect, useState, useRef } from "react";
import "./App.css";
import Keycloakentrypoint from "./KeycloakRoutings/Keycloakentrypoint";


const App = () => {


  return (
    <>
    <Keycloakentrypoint/>
    </>
  );
};

export default App;
